<template>
  <div class="platform-game-versions-label-component" :class="{ 'align-right': alignRight }">
    <div v-for="platform in platforms" :key="platform.id" class="platform">
      <i :class="['pi', { 'pi-apple': platform.name === 'iOS' }, { 'pi-android': platform.name === 'Android' }]" />

      <span class="version">
        <span v-if="!platform.versions.from && !platform.versions.to">all versions</span>
        <span v-else>
          <span v-if="platform.versions.from">
            <span v-if="!platform.versions.to">&geq;</span>
            v{{ platform.versions.from }}
          </span>

          <span v-if="platform.versions.to">
            <span v-if="platform.versions.from">&nbsp;to&nbsp;</span>
            <span v-else>&leq;</span>
            v{{ platform.versions.to }}
          </span>
        </span>
      </span>
    </div>
    <div v-if="!platforms.length" class="platform">No Platforms - No Versions</div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue";

import { GamePlatform } from "@/graphql";

export default defineComponent({
  name: "PlatformGameVersionsLabel",
  props: {
    value: {
      type: Object as PropType<GamePlatform | null>,
      default: () => null,
    },

    alignRight: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const platforms = computed(() => {
      if (!props.value) {
        return [];
      }

      let result: { id: string; name: string; versions: { from: string; to: string } }[] = [];

      if (props.value.ios) {
        result = [
          ...result,
          {
            id: "ios",
            name: "iOS",
            versions: { from: props.value.iosGameVersionFrom, to: props.value.iosGameVersionTo },
          },
        ];
      }

      if (props.value.android) {
        result = [
          ...result,
          {
            id: "android",
            name: "Android",
            versions: { from: props.value.androidGameVersionFrom, to: props.value.androidGameVersionTo },
          },
        ];
      }

      return result;
    });

    return {
      platforms,
    };
  },
});
</script>

<style lang="scss" scoped>
.platform-game-versions-label-component {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: font("XS");
  color: $slate;
  line-height: font("XS");

  &.align-right {
    justify-content: flex-end;
  }

  .platform {
    margin-bottom: size("XXS");
    display: flex;
    align-items: center;

    i {
      display: inline-block;
      margin-right: size("XXS");
    }
  }

  .platform:after {
    content: "•";
    margin: 0 size("XS");
  }

  .platform:last-child:after {
    content: "";
    margin: 0;
  }
}
</style>
